export type PaginationAndSort = {
  page?: number;
  limit?: number;
  sort?: string[];
};

export type ListResponse<T> = {
  data: T[];
  total: number;
};

export type ListResponseWithPagination<T> = {
  content: T[];
  empty: boolean;
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  numberOfElements: number;
  pageable: Pageable;
  sort: Sort;
  first: boolean;
  last: boolean;
};

export type Pageable = {
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  unpaged: boolean;
  sort: Sort;
};

export type Sort = {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
};

export enum EducationLevel {
  Noo = 'NOO',
  Ooo = 'OOO',
  Soo = 'SOO',
}
